<template>
  <el-card class="container">
    <el-row>
      <el-col :span="20">
        <el-input size="small" v-model="searchBody.app_id" placeholder="请输入app Id"
          class="search-input" clearable></el-input>
        <el-input size="small" v-model="searchBody.name" placeholder="请输入app名称"
          class="search-input" clearable></el-input>
        <el-input size="small" v-model="searchBody.system" placeholder="请输入system"
          class="search-input" clearable></el-input>
        <el-button size="small" type="primary" style="margin-left: 20px" icon="el-icon-search" @click="search">
          搜索
        </el-button>
      </el-col>
      <el-col :span="4">
        <el-button size="small" type="primary" class="float-right" icon="el-icon-plus" @click="addApp" v-if="isAdmin">新增APP</el-button>
      </el-col>
    </el-row>
    <el-table :data="tableData" style="margin-top: 20px">
      <el-table-column
        v-for="col of tableColumns"
        :key="col.prop"
        :prop="col.prop"
        :label="col.label"
        :width="col.width">
        <template slot-scope="scope">
          <el-image v-if="col.prop=='icon'"
            :src="scope.row.icon"
            style="width: 32px; height: 32px; text-align:center">
            <div slot="error" class="image-slot">
              <i class="el-icon-picture-outline"></i>
            </div>
          </el-image>
          <span v-else-if="col.prop=='os_type'">{{ osTypeMap[scope.row[col.prop]] }}</span>
          <span v-else>{{ scope.row[col.prop] }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        width="160" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="edit(scope.row)">编辑</el-button>
          <el-button type="text" size="small" @click="editRemoteConf(scope.row)" v-if="isAdmin">配置下发</el-button>
          <el-button type="text" size="small" @click="deleteApp(scope.row)" v-if="isAdmin">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      v-if="tableData.length > 0"
      layout="prev, pager, next"
      :total="totalCount"
      :page-size="limit"
      style="float: right; margin: 20px 0"
      @current-change="changePage">
    </el-pagination>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="40%"
      :before-close="handleClose">
      <el-form ref="appForm" :rules="appFormRules" :model="appForm" label-width="150px">
        <el-form-item label="Name" prop="name" v-if="isAdmin">
          <el-input v-model="appForm.name"></el-input>
        </el-form-item>
        <el-form-item label="PackageName" prop="package_name" v-if="isAdmin">
          <el-input v-model="appForm.package_name"></el-input>
        </el-form-item>
        <el-form-item label="OsType" prop="os_type" v-if="isAdmin">
          <el-select v-model="appForm.os_type">
            <el-option
              v-for="osType of osTypes"
              :key="osType.value"
              :label="osType.label"
              :value="osType.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Icon" v-if="isAdmin">
          <el-upload
            class="avatar-uploader"
            action="https://data.answeraiops.com/nfs/v1.0/file/upload"
            :show-file-list="false"
            :on-success="handleUploadSuccess">
            <div v-if="loadImage">
              <img v-if="appForm.icon" :src="appForm.icon" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="Domain" v-if="isAdmin" prop="domain">
          <el-input v-model="appForm.domain"></el-input>
        </el-form-item>
        <el-form-item label="NatsSubject" v-if="isAdmin" prop="nats_subject">
          <el-input v-model="appForm.nats_subject"></el-input>
        </el-form-item>
        <el-form-item label="System" v-if="isAdmin" prop="system">
          <el-input v-model="appForm.system"></el-input>
        </el-form-item>
        <el-form-item label="TableauShareLink" v-if="isAdmin">
          <el-input v-model="appForm.tb_share_link"></el-input>
        </el-form-item>
        <el-form-item label="SyncES">
          <el-switch v-model="appForm.sync_es"></el-switch>
        </el-form-item>
        <el-form-item label="Disabled" v-if="isAdmin">
          <el-switch v-model="appForm.disabled"></el-switch>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="配置下发" width="40%"
      :visible.sync="remoteConfDialogVisible"
      :before-close="handleCloseRemoteConf">
      <el-tabs v-model="tabActiveName" type="card" @tab-click="handleClickTab">
        <el-tab-pane label="SDK远程开关" name="sdk_control">
          <el-form ref="rmtConfForm" :model="rmtConfForm" label-width="150px">
            <el-form-item label="autoTrackMode" prop="autoTrackMode">
              <el-select v-model="rmtConfForm.autoTrackMode" multiple clearable>
                <el-option v-for="tm of autoTrackModes" :key="tm.value" :label="tm.label" :value="tm.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="disableDebugMode" prop="disableDebugMode">
              <el-switch v-model="rmtConfForm.disableDebugMode"></el-switch>
            </el-form-item>
            <el-form-item label="disableSDK" prop="disableSDK">
              <el-switch v-model="rmtConfForm.disableSDK"></el-switch>
            </el-form-item>
            <el-form-item label="effectMode" prop="effect_mode">
              <el-select v-model="rmtConfForm.effect_mode">
                <el-option :key="0" label="Next Time" :value="0"></el-option>
                <el-option :key="1" label="Immediately" :value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="eventBlacklist" prop="event_blacklist">
              <el-select v-model="rmtConfForm.event_blacklist" filterable multiple clearable allow-create default-first-option>
                <el-option v-for="event of appEvents" :key="event.event" :label="event.event" :value="event.event">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="抽样管理" name="samp_conf">
          <el-divider content-position="left">抽样配置，当前版本：
            <el-select v-model="selectedVerIndex" size="mini" @change="changeVersion">
              <el-option v-for="(sh, idx) of sampHistory"
                :key="sh.version"
                :label="sh.version"
                :value="idx"></el-option>
            </el-select>
          </el-divider>
          <el-tag v-for="(sc, idx) of sampConfs" :key="idx" effect="plain" style="font-weight:bold;margin:5px" closable @close="removeSamp(idx)" @click="clickSamp(idx)">
            <span>{{sc.event_name}}</span><span v-if="sc.param!=''">({{sc.param}}<span v-if="sc.value!=''">={{sc.value}}</span>)</span><span>,mode:{{sc.mode}}</span><span>,ratio:{{sc.ratio}}</span>
          </el-tag>
          <el-divider content-position="left">新增抽样配置</el-divider>
          <el-form ref="sampConfForm" :model="sampConfForm" label-width="80px">
            <el-row>
              <el-col>
                <el-form-item label="事件名">
                  <el-select v-model="sampConfForm.event_name"
                    filterable clearable allow-create default-first-option size="mini">
                    <el-option v-for="event of appEvents" :key="event" :label="event" :value="event">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="10">
                <el-form-item label="参数名">
                  <el-select v-model="sampConfForm.param"
                    filterable clearable allow-create default-first-option size="mini">
                    <el-option v-for="prop of eventProps" :key="prop" :lable="prop" :value="prop">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="参数值">
                  <el-select v-model="sampConfForm.value"
                    filterable clearable allow-create default-first-option size="mini">
                    <el-option v-for="value of propValues" :key="value" :lable="value" :value="value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="10">
                <el-form-item label="抽样类型">
                  <el-select v-model="sampConfForm.mode"
                    filterable clearable allow-create default-first-option size="mini">
                    <el-option v-for="s of sampModes" :key="s.mode" :lable="s.name" :value="s.mode">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="抽样比例">
                  <el-input-number v-model="sampConfForm.ratio" :min="0" :max="1" :precision="3" :step="0.001" label="采样比率" size="mini">
                  </el-input-number>
                </el-form-item>
              </el-col>
            </el-row>
            <el-button type="primary" size="mini" @click="submitSamp">确认</el-button>
            <el-button type="info" size="mini" @click="resetSamp">重置</el-button>
          </el-form>
          <el-divider content-position="left" v-if="sampHistory.length > 0">历史版本</el-divider>
           <el-checkbox-group v-model="diffList" :max="2">
             <el-checkbox v-for="sh of sampHistory" :label="JSON.stringify(sh, null, 4)" :key="sh.version">版本: {{sh.version}}</el-checkbox>
          </el-checkbox-group>
          <el-button type="primary" size="mini" @click="diffSamp" :disabled="diffList.length != 2"
            style="margin-top: 20px" v-if="sampHistory.length > 0">对比</el-button>
        </el-tab-pane>
        <el-tab-pane label="配置管理" name="app_conf">
          <el-form ref="appConfForm" :model="appConfForm" label-width="150px">
            <el-form-item label="Ratio(%)">
              <el-input-number v-model="appConfForm.ratio" :min="0" :max="100" label="采样比率">
              </el-input-number>
            </el-form-item>
            <el-form-item label="Config">
              <el-input type="textarea" v-model="appConfForm.conf" :autosize="{minRows: 5}">
              </el-input>
            </el-form-item>
          </el-form>
        </el-tab-pane>
      </el-tabs>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCloseRemoteConf">取 消</el-button>
        <el-button type="primary" @click="submitRemoteConf">确 定</el-button>
      </span>
      <el-dialog width="60%" title="版本对比" :visible.sync="diffDialogVisible" append-to-body>
        <code-diff
          :old-string="diffList[0]"
          :new-string="diffList[1]"
          file-name="test.txt"
          output-format="side-by-side"/>
      </el-dialog>
    </el-dialog>
  </el-card>
</template>

<script>

  const osTypes = [
    { value: 1, 'label': 'Android' },
    { value: 2, 'label': 'IOS' },
    { value: 4, 'label': 'Web' },
  ]

  const osTypeMap = {
    1: 'Android',
    2: 'IOS',
    4: 'Web',
  }

  const tableColumns = [
    { prop: 'id', label: 'Id', width: 90},
    { prop: 'name', label: 'Name', width: 150 },
    { prop: 'icon', label: 'Icon', width: 80 },
    { prop: 'package_name', label: 'PackageName' },
    { prop: 'os_type', label: 'OsType', width: 100 },
    { prop: 'system', label: 'System', width: 100 },
    { prop: 'domain', label: 'Domain' },
    { prop: 'nats_subject', label: 'NatsSubject', width: 120},
    { prop: 'sync_es', label: 'SyncES', width: 80 },
    { prop: 'disabled', label: 'Disabled', width: 80 }
  ]

  const autoTrackModes = [
    { value: 1, label: 'AppStart'},
    { value: 2, label: 'AppEnd'},
    { value: 4, label: 'AppClick'},
    { value: 8, label: 'AppViewScreen'},
  ]

  export default {
    props: {
      isAdmin: Boolean
    },
    data () {
      return {
        loading: false,
        appForm: {},
        osTypes: osTypes,
        osTypeMap: osTypeMap, 
        searchText: "",
        searchBody: { app_id: '', name: '', system: ''},
        tableData: [],
        tableColumns: tableColumns,
        autoTrackModes: autoTrackModes,
        totalCount: 0,
        dialogTitle: '',
        limit: 15,
        page: 1,
        loadImage: true,
        tabActiveName: 'sdk_control',
        currentRow: undefined,
        dialogVisible: false,
        remoteConfDialogVisible: false,
        rmtConfForm: {
          autoTrackMode: [],
          disableDebugMode: true,
          disableSDK: false,
          effect_mode: 1,
          event_blacklist: []
        },
        appConfForm: {
          ratio: 0,
          conf: undefined,
        },
        defaultSampConf: {
          event: '',
          param: '',
          value: '',
          mode: 'dev',
          ratio: 1
        },
        sampConfForm: {
          event_name: '',
          param: '',
          value: '',
          mode: 'dev',
          ratio: 1
        },
        sampModes: [{name: '设备ID抽样', mode: 'dev'}, {name: '随机抽样', mode: 'rand'}],
        appEvents: [],
        eventProps: [],
        propValues: [],
        sampConfs: [],
        sampVersion: undefined,
        sampHistory: [],
        diffList: [],
        diffDialogVisible: false,
        selectedVerIndex: 0,
        appFormRules: {
          name: [
            { required: true, message: '请输入AppName', trigger: 'blur' },
          ],
          package_name: [
            { required: true, message: '请输入PackageName', trigger: 'change' }
          ],
          os_type: [
            { required: true, message: '请选择OSType', trigger: 'change' }
          ],
          system: [
            { required: true, message: '请输入System', trigger: 'blur' }
          ],
          domain: [
            { required: true, message: '请输入Domain', trigger: 'blur' }
          ],
          nats_subject: [
            { required: true, message: '请输入NatsSubject', trigger: 'blur' }
          ],
        }
      }
    },
    methods:{
      search() {
        this.page = 1;
        this.getApps();
      },
      async getApps () {

        // let txt = this.searchText.trim();
        let {app_id, name, system} = this.searchBody;

        let offset = (this.page - 1) * this.limit;
        let url = `/etp/app/list?offset=${offset}&limit=${this.limit}&app_id=${app_id.trim()}&name=${name.trim()}&system=${system.trim()}`

        let rst = await this.$http.get(url);
        let tableData = rst.data.data || [];

        this.tableData  = tableData;
        this.totalCount = rst.data.total;

      },
      handleUploadSuccess(response, file, fileList) {
        this.loadImage = false;
        this.appForm.icon = response.data.url;
        this.loadImage = true;
      },
      addApp() {
        this.appForm = {};
        this.dialogVisible = true;
      },
      edit(row) {
        this.appForm = JSON.parse(JSON.stringify(row));
        this.dialogVisible = true;
      },
      handleClose() {
        this.dialogVisible = false;
        this.$refs['appForm'].clearValidate();
      },
      removeSamp(idx) {
        this.sampConfs.splice(idx, 1);
      },
      clickSamp(idx) {
        let sc = JSON.parse(JSON.stringify(this.sampConfs[idx]));
        sc.idx = idx;
        this.sampConfForm = sc;
      },
      submitSamp() {
        this.sampConfs = this.sampConfs || [];
        let sc = JSON.parse(JSON.stringify(this.sampConfForm));
        if (this.sampConfForm.idx != undefined) {
          this.sampConfs[this.sampConfForm.idx] = sc;
        } else {
          this.sampConfs.push(sc);
        }
        this.sampConfForm = JSON.parse(JSON.stringify(this.defaultSampConf));
      },
      resetSamp() {
        this.sampConfForm = JSON.parse(JSON.stringify(this.defaultSampConf));
      },
      async editRemoteConf(row) {
        this.currentRow = row;
        this.tabActiveName = 'sdk_control';
        await this.getAppRemoteConf(row.id);
        this.getAppConf(row.id);
        this.remoteConfDialogVisible = true;
        this.getAppEvents(row.id);
        // this.getSampConf(row.id);
        this.getSampHistory(row.id);
      },
      async getAppRemoteConf(appId) {
        let url = `/etp/setting/remote/detail?app_id=${appId}`;
        let rst = await this.$http.get(url);
        let d = rst.data.data;
        d.autoTrackMode = this.int2trackmodes(d.autoTrackMode);
        d.app_id = appId;
        this.rmtConfForm = d;
      },
      async getAppConf(appId) {
        let url = `/etp/setting/appconf/detail?app_id=${appId}`;
        let rst = await this.$http.get(url);
        let d = rst.data.data;
        d.app_id = appId;
        this.appConfForm = d;
      },
      handleCloseRemoteConf() {
        this.remoteConfDialogVisible = false;
      },
      changePage(val) {
        this.page = val;
        this.getApps();
      },
      deleteApp(row) {
        this.$confirm(`确认删除${row.name}(${row.package_name})?`)
          .then(async () => {
            let rst = await this.$http.post('/etp/app/delete', { id: [row.id] });

            if (rst.data.err_code == 0) {
              this.$notify({
                title: '提示',
                message: '删除成功',
                type: 'success'
              })
            }

            this.getApps();

          })
          .catch(_ => {
            this.getApps();
          });
      },
      async getAppEvents(app) {
        let events = await this.getEventParams(app);
        this.appEvents = events;
      },
      async getEventProperties(ev) {
        let props = await this.getEventParams(`${this.appForm.app}::${ev}`);
        this.properties = props;
      },
      async getEventPropertyValues(eventName, propName) {
        let pv = await this.getEventParams(`${this.currentRow.name}::${eventName}::${propName}`);
        this.propValues = pv;
      },
      async getEventParams(key) {

        let url = `/etp/v1.0/event/params/list?key=${key}&system=${this.$route.params.system}`;
        let rst = await this.$http.get(url)

        return rst.data.data.map(p => p.value);
      },
      async submit () {

        this.$refs['appForm'].validate(async (valid) => {

          if (!valid) {
            this.$notify({
              title: "警告",
              message: "请输入必填信息",
              type: "warning"
            })
            return;
          }

          let rst = await this.$http.post('/etp/app/save', JSON.stringify(this.appForm));
          if (rst.data.err_code == 0) {
            this.$notify({
              title: '提示',
              message: '保存成功',
              type: 'success'
            })
            this.dialogVisible = false;
            this.getApps();
          }

        })

      },
      int2trackmodes(n) {
        let s = Number(n).toString(2);
        let l = s.length;
        let mods = [];
        for (let i=0; i<l; i++) {
          if (s[i] == '1') {
            mods.push(1 << (l-1-i))
          }
        }
        return mods
      },
      handleClickTab(tab, event) {
      },
      async submitRemoteConf() {
        let succ = false;

        if (this.tabActiveName=='sdk_control') {
          succ = await this.saveSDKConf();
        } else if (this.tabActiveName == 'app_conf') {
          succ = await this.saveAppConf();
        } else if (this.tabActiveName == 'samp_conf'){
          succ = await this.saveSampConf();
        } else {
          return;
        }

        if (succ) {
          this.$notify({
            title: '提示',
            message: '保存成功',
            type: 'success'
          })
          this.remoteConfDialogVisible = false;
        };
      },
      async saveSDKConf() {
        let d = JSON.parse(JSON.stringify(this.rmtConfForm));

        d.autoTrackMode = d.autoTrackMode.length == 0 ? 0: d.autoTrackMode.reduce((x, y) => x + y);

        let url = `/etp/setting/remote/save`;

        let rst = await this.$http.post(url, JSON.stringify(d));

        return rst.data.err_code == 0;
      },
      async saveAppConf() {
        let d = JSON.parse(JSON.stringify(this.appConfForm));

        let url = `/etp/setting/appconf/save`;

        let rst = await this.$http.post(url, JSON.stringify(d));

        return rst.data.err_code == 0;
      },
      // async getSampConf(appId) {

      //   let url = `/etp/setting/samplingevent/detail?app_id=${appId}`;

      //   let res = await this.$http.get(url);

      //   this.sampConfs = res.data.data.event_ratios;
      //   this.sampVersion  = res.data.data.version;

      // },
      async saveSampConf() {
        let d = JSON.parse(JSON.stringify(this.sampConfs));
        let data = {
          app_id: this.currentRow.id,
          event_ratios: d
        }

        let url = '/etp/setting/samplingevent/save';
        let rst = await this.$http.post(url, JSON.stringify(data));

        return rst.data.err_code == 0;
      },
      async getSampHistory(appId) {

        let url = `/etp/setting/samplingevent/history?app_id=${appId}`;
        let res = await this.$http.get(url)

        this.sampHistory = res.data.data;
        this.selectedVerIndex = 0;
        this.changeVersion();

      },
      diffSamp() {
        this.diffDialogVisible = true;
      },
      changeVersion() {
        this.sampConfs    = this.sampHistory[this.selectedVerIndex].event_ratios;
        this.sampVersion  = this.sampHistory[this.selectedVerIndex].version;
      },
    },
    mounted() {
      this.getApps();
    }
  }
</script>


<style lang="less" scoped>
  .container {
    margin: 20px;
  }
  .search-input {
    width: 240px;
    margin: 0 20px;
  }
  .float-right {
    margin: 0 20px;
    float: right;
  }

  .avatar-uploader {
    width: 64px;
    height: 64px;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 24px;
    color: #8c939d;
    width: 64px;
    height: 64px;
    line-height: 64px;
    text-align: center;
  }

  .avatar {
    width: 64px;
    height: 64px;
    display: block;
  }

</style>
